
import { RmColumns } from "../rm-columns-entity";
import { RmColumnsDTO } from "./rm-columns-dto";





export class RmColumnsAdapter {

    public convertDtoToEntity(details: RmColumnsDTO): RmColumns {
        const columns = new RmColumns();
        if(details.columnsId){
            columns.columnsId = details.columnsId;
            columns.updatedUser =details.updatedUser;
        }
        columns.columnsCode = details.columnsCode;
        columns.columnsNo = details.columnsNo;
        columns.createdUser =details.createdUser;
        return columns;
    }
    
}